// UI mirror of the backend's immutable source policy, never an authority for server approval.
// This verifies source identity only. A human must inspect the rendered logo separately.
export const SR_ENGINE_BRAND_POLICY=Object.freeze({policyId:'sr-brand-owner-approved-2026-10-23-v1',sha256:'0c627b71fb8e1613cc12ae28c427ead55377c6b13623f6c9f534b7dca27bd9df',type:'image/jpeg'})
export const isApprovedSRBrandSource=asset=>Boolean(asset&&asset.role!=='artwork_engine_output'&&asset.type===SR_ENGINE_BRAND_POLICY.type&&asset.sha256===SR_ENGINE_BRAND_POLICY.sha256)
export function hasSavedSRBrandReference(job){
 const spec=job.artworkEngine?.spec,ref=spec?.srBrandReference
 if(spec?.mode==='cad_handoff'&&!spec.srBrandAssetId&&!ref)return true
 return Boolean(ref&&ref.policyId===SR_ENGINE_BRAND_POLICY.policyId&&ref.assetId===spec.srBrandAssetId&&ref.sha256===SR_ENGINE_BRAND_POLICY.sha256&&job.assets?.some(a=>a.id===ref.assetId&&isApprovedSRBrandSource(a)))
}

export async function readApprovedSRBrandSource(read=fetch){
 const response=await read('/reference/sr-approved-brand.jpeg')
 if(!response.ok)throw Error('The approved SR source could not be loaded.')
 const bytes=await response.arrayBuffer()
 const sha256=Array.from(new Uint8Array(await crypto.subtle.digest('SHA-256',bytes)),b=>b.toString(16).padStart(2,'0')).join('')
 if(sha256!==SR_ENGINE_BRAND_POLICY.sha256)throw Error('The SR source does not match the approved brand policy. Do not use a replacement.')
 return new File([bytes],'sr-approved-brand.jpeg',{type:SR_ENGINE_BRAND_POLICY.type})
}
